module.exports = __webpack_public_path__ + "static/3D.61682081.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/3D.png
// module id = 780
// module chunks = 118514840243029